import styles from "../styles/_BlockTitleCS.module.scss";
import FontAwesome from "../../../utilities/FontAwesome";

export const FetchMoreNewsButton = (props: {
  onClick: () => void;
  isLoading: boolean;
}) => {
  return (
    <div
      style={{ textAlign: "center" }}
      className={styles.viewMoreButtonContainer}
    >
      {props.isLoading ? (
        <FontAwesome name={"fa-spinner"} prefix={"fas"} size={"3x"} spin />
      ) : (
        <button onClick={props.onClick}>View More</button>
      )}
    </div>
  );
};
